<template>
  <l-layer-group>
    <MapCircleMarker
      v-for="marker in markers"
      :key="marker.id"
      :coords="marker.coords"
      :label="marker.label"
      :color="marker.color"
    ></MapCircleMarker>
    <MapColorMarker
      v-if="centerMarker"
      :coords="centerMarker.coords"
      :label="centerMarker.label"
      :color="centerMarker.color"
    ></MapColorMarker>
  </l-layer-group>
</template>

<script>
import { LLayerGroup } from "vue2-leaflet";
import MapCircleMarker from "@/components/ui/Map/CircleMarker.vue";
import MapColorMarker from "@/components/ui/Map/ColorMarker.vue";
import cuid from "cuid";
import { getVisibilityLevelData } from "@/config/visibility_level";

export default {
  name: "MapVisibilityExtremesLayer",
  components: {
    LLayerGroup,
    MapCircleMarker,
    MapColorMarker
  },
  props: {
    squares: {
      type: Array,
      required: true,
      validator: array => {
        return array.length === 256;
      }
    }
  },
  watch: {
    squares() {
      this.initMarkers();
    }
  },
  data() {
    return {
      markers: [],
      centerMarker: null
    };
  },
  mounted() {
    this.initMarkers();
  },
  methods: {
    initMarkers() {
      this.centerMarker = this.setMarker(136, 0);
      this.markers = [
        this.setMarker(0, 0), //top-left
        this.setMarker(8, 0), //top
        this.setMarker(15, 1), //top-right
        this.setMarker(128, 0), //right
        this.setMarker(143, 1), //bottom-right
        this.setMarker(255, 3), //bottom
        this.setMarker(248, 2), //bottom-left
        this.setMarker(240, 2) //left
      ];
    },
    setMarker(squareIndex, coordsIndex) {
      const [x, y, intensity] = this.squares[squareIndex].points[coordsIndex];
      const { color, label } = getVisibilityLevelData(intensity);

      return {
        id: cuid(),
        coords: [x, y],
        label,
        color
      };
    }
  }
};
</script>
